<div class="d-flex flex-row">
    @if (workItemId() !== 'new') {
        <div class="flex-grow-1">
            <telxl-panel
                cardClass="h-100"
                [height]="height()"
                [minHeight]="height()"
            >
                <ng-template #cardBody>
                    <div class="d-flex">
                        <div class="ps-2 voice-width">
                            <voice-call />
                        </div>
                        @if (contacts().display) {
                            <div class="flex-grow-1 ps-2">
                                <voice-contacts-directory
                                    [state]="{
                                        title: contacts().title,
                                        action: contacts().action!,
                                        close: true,
                                    }"
                                    [workItemId]="workItem()?.workItemId"
                                    [conversationId]="conversationId()"
                                    (closed)="contactsClose($event)"
                                />
                            </div>
                        }
                    </div>
                </ng-template>
            </telxl-panel>
        </div>
    } @else {
        <div class="container-fluid">
            @let showEditPanel = showCustomerEditPanel();
            @let currentTab = contactStore.currentTab();
            <div class="row">
                <div class="col-3 p-0">
                    <telxl-panel
                        cardClass="h-100 overflow-auto"
                        [minHeight]="height()"
                        [maxHeight]="height()"
                        bodyClass="pe-2"
                    >
                        <ng-template #cardBody>
                            <div class="ps-2">
                                <voice-call-new
                                    [contactSelected]="newCallContact()"
                                />
                            </div>
                        </ng-template>
                    </telxl-panel>
                </div>
                <div class="pe-1" [ngClass]="{ 'col': !showEditPanel, 'col-5': showEditPanel }">
                    <telxl-panel
                        cardClass="h-100"
                        [minHeight]="height()"
                        [maxHeight]="height()"
                    >
                        <ng-template #cardBody>
                            <div class="ps-2">
                                <voice-contacts-directory
                                    [state]="{
                                        title: '',
                                        action: 'voice-new',
                                        close: false,
                                    }"
                                    [conversationId]="conversationId()"
                                    [workItemId]="workItem()?.workItemId"
                                    (selected)="contactSelected($event, true)"
                                    (closed)="contactsClose($event)"
                                />
                            </div>
                        </ng-template>
                    </telxl-panel>
                </div>
                
                <div [ngClass]="{ 'col-4 pe-1 edit-customer__panel--active': showEditPanel, 'edit-customer__panel--hidden': showTemporaryExitStyling() }">

                    @if (showEditPanel) {
                        @if (currentTab === 'customers' && !contactStore.contactSelectionEmpty()) {
                            <customer-interactions [customer]="contactStore.currentSelectedContactId()" [autoRefreshOnUpdate]="true" />
                        }

                        @if (currentTab === 'contacts' && !contactStore.contactSelectionEmpty()) {
                            <contact-directories [contact]="contactStore.currentSelectedContactDetail()" [autoRefreshOnUpdate]="true" />
                        }

                        @if (contactStore.contactSelectionEmpty()) {
                            <telxl-panel cardClass="h-100">
                                <div class="d-flex flex-column w-100 h-100 align-items-center justify-content-center">
                                    <i class="fa-thin fa-face-monocle fa-5x text-primary mb-4"></i>
                                    <div>Select a contact to</div>
                                    <div>view further details</div>
                                </div>
                            </telxl-panel>
                        }
                    }

                </div>                    

            </div>
        </div>
    }
</div>
